<template>
  <div class="header" v-if="isMobileDevice">
    <div class="left" @click="onback">
      <svg t="1737004586108" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12832" width="64" height="64"><path d="M659.748571 245.272381l-51.687619-51.687619-318.439619 318.585905 318.415238 318.268952 51.712-51.736381-266.703238-266.556952z" p-id="12833"></path></svg>
    </div>

    <div class="title">
      {{title}}
    </div>
  </div>
</template>

<script>
  import { isMobileDevice } from "@/utils/index";
  export default {
      props: {
        title: {
          default: '',
        }
      },
      data() {
        return {
           isMobileDevice: isMobileDevice()
        }
      },
      methods: {
        onback() {
          this.$router.back()
        }
      }


  }
</script>

<style scoped lang="scss">
  .header {
    display: flex;
    height: 12.26667vw;
    position: relative;
    align-items: center;
        position: sticky;
        top: 0;
        background: #fff;
        z-index: 999;
    .left {
      position: absolute;
      display: flex;
      align-items: center;
      top: 0;
      bottom: 0;
      padding: 16px;
      .icon {
        width: 30px;
        height: 30px;
      }
    }
    .title {
      width: 100%;
      text-align: center;
      font-size:  4.26667vw;
      font-weight: 600;
    }
  }
</style>
